import { ALL_GEOGRAPHIES } from 'tools/jce-geography/JceHomepageGeographyListRoute';
import {
  JceGeographyAttributesForm,
  JceHomepageGeographyFormValues,
} from './JceGeographyAttributesForm';
import { gql } from '@apollo/client';
import { useUpdateJceHomepageGeographyMutation } from 'generated/graphql';
import React from 'react';

gql`
  mutation UpdateJceHomepageGeography($geography: JceHomepageGeographyInput!) {
    updateJceHomepageGeography(geography: $geography) {
      id
      name
      urlSlug
      resyBlogKey
      tier
      priorityWithinTier
    }
  }
`;

interface JceGeographyEditAttributesProps {
  geographyId: number;
  initialValues: JceHomepageGeographyFormValues;
}

const JceGeographyEditAttributes: React.FC<JceGeographyEditAttributesProps> = ({
  geographyId,
  initialValues,
}) => {
  const [updateGeography] = useUpdateJceHomepageGeographyMutation();

  const onSubmit = async (values: JceHomepageGeographyFormValues) => {
    await updateGeography({
      variables: {
        geography: {
          id: geographyId,
          name: values.name,
          urlSlug: values.urlSlug,
          resyBlogKey: values.resyBlogKey,
          tier: values.tier,
          priorityWithinTier: values.priorityWithinTier,
        },
      },
      refetchQueries: [{ query: ALL_GEOGRAPHIES }],
    });
  };

  return (
    <JceGeographyAttributesForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitLabel="Save Changes"
    />
  );
};

export default JceGeographyEditAttributes;
